import { render, staticRenderFns } from "./Compactlist.vue?vue&type=template&id=cf6d45bc&"
import script from "./Compactlist.vue?vue&type=script&lang=js&"
export * from "./Compactlist.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports